import diggingDogPng from './digging-dog.png';
import diggingDogWebP from './digging-dog.webp';

export const diggingDogSources = [diggingDogWebP, diggingDogPng];
